import type {
  GlobalPatientSearchResponse,
  ConsentRequestPayload,
  ConsentRequestResponse,
  ConsentPageDto,
  SharedHistoryDto,
  ConsentListItem,
} from '../../../types';
import { fetchApi } from '../client';

export const consentModule = {
  // Global patient search
  searchGlobalPatient: (params: { mobile?: string; name?: string; dob?: string; abhaId?: string }) =>
    fetchApi<GlobalPatientSearchResponse>('/api/v1/patients/global/search', {
      method: 'POST',
      body: JSON.stringify(params),
    }),

  // Create consent request (OTP or QR)
  requestConsent: (payload: ConsentRequestPayload) =>
    fetchApi<ConsentRequestResponse>('/api/v1/patients/consents/request', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  // Verify OTP
  verifyOtp: (consentId: string, otp: string) =>
    fetchApi<Record<string, unknown>>('/api/v1/patients/consents/verify-otp', {
      method: 'POST',
      body: JSON.stringify({ consentId, otp }),
    }),

  // QR page (public — patient's phone)
  getQrConsentPage: (token: string) =>
    fetchApi<ConsentPageDto>(`/api/v1/patients/consents/qr/${token}`),

  // QR approve (public — patient's phone)
  approveQr: (payload: {
    token: string;
    signedName: string;
    dobConfirmed?: string;
    signatureDataUrl?: string;
  }) =>
    fetchApi<Record<string, unknown>>('/api/v1/patients/consents/qr/approve', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),

  // Revoke consent (staff)
  revokeConsent: (consentId: string, reason?: string) =>
    fetchApi<Record<string, unknown>>('/api/v1/patients/consents/revoke', {
      method: 'POST',
      body: JSON.stringify({ consentId, reason }),
    }),

  // Revoke via patient self-service token
  revokeByToken: (revokeToken: string, reason?: string) =>
    fetchApi<Record<string, unknown>>('/api/v1/patients/consents/revoke', {
      method: 'POST',
      body: JSON.stringify({ revokeToken, reason }),
    }),

  // Get shared history for a patient
  getSharedHistory: (clinicPatientId: string) =>
    fetchApi<SharedHistoryDto>(`/api/v1/patients/${clinicPatientId}/shared-history`),

  // List all consents for current clinic
  listConsents: () =>
    fetchApi<ConsentListItem[]>('/api/v1/patients/consents'),
};
